// extracted by mini-css-extract-plugin
module.exports = {"resetBtn":"_3fei_fMkcM_kZuDbBtmdWO","icon":"_10euqRvXd7zcBzTVpJMv_2","active":"_3dtPG8zjxSKIBNcNdTmDtc"};